import React, {memo} from 'react';
import {ListItem} from '@mui/material';
import DiplomatStateStatusIcon from 'components/icons/DiplomatStateStatusIcon';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import {useDrag} from 'react-dnd';
import {DragObjectType} from 'features/layout/SideNav/components/types';
import history from 'redux/history';
import {packId} from 'common/diplomatIdUtil';
import {useIsPermittedOptionDeffered} from 'common/hooks/useIsPermitted';
import {DiplomatObjectAceType} from 'types/diplomat/settings/permissions/DiplomatObjectAceType';

const ResultItem = memo(
   ({
      name,
      id,
      type,
      folderId,
   }: {
      name: string;
      id: string;
      folderId: string;
      type: DiplomatObjectTypeUnion;
   }) => {
      const [isPermitted, checkPermission] = useIsPermittedOptionDeffered(
         DiplomatObjectAceType.enum.REMOVE_OBJECT,
         type,
         id,
         true
      );

      const [, drag] = useDrag(
         () => ({
            // canDrag: isPermitted,
            type,
            item: () => {
               checkPermission();
               return {type, id} as DragObjectType;
            },
            collect: (monitor) => ({
               isDragging: !!monitor.isDragging(),
            }),
            isDragging: () => isPermitted ?? true,
         }),
         [isPermitted, type, id]
      );

      const onDblClick = React.useCallback(() => {
         if (window.opener) {
            window.opener.pushLocation(`/${packId(type, id)}`);
         } else {
            history.push(`/${packId(type, id)}`);
         }
      }, [type, id]);

      return (
         <ListItem
            ref={drag}
            onDoubleClick={onDblClick}
            // onFocus={checkPermission}
            // onMouseEnter={checkPermission}
            button
         >
            <DiplomatStateStatusIcon name={name} folderId={folderId} /> {name}
         </ListItem>
      );
   }
);

export default ResultItem;
